import { apiRoutes } from "@constants/api-routes";
import { handleRequestWithBody } from "@utils/http-util";
import { injectWorkflowIdAndChangeRequestStatus } from "@utils/parameter-injector";
import { RequestTypes } from "@enums/request-types";
import { ChangeRequestStatusTypes } from "@enums/change-request-status-types";
import { WorkflowChangeRequest } from "@idw-types/data/workflow-change-request";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type UpdateWorkflowChangeRequestRequestResponse = {
    transferObject: WorkflowChangeRequest;
};

export const updateWorkflowChangeRequestRequest = async (
    workflowId: string,
    body: { [key: string]: any },
    changeRequestStatus: ChangeRequestStatusTypes
): Promise<GenericNetworkResponse<UpdateWorkflowChangeRequestRequestResponse>> => {
    const route = injectWorkflowIdAndChangeRequestStatus(
        apiRoutes.serviceConfiguration.workflowConfig.changeRequest.workflow.updateChangeRequest,
        workflowId,
        changeRequestStatus
    );
    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};